// extracted by mini-css-extract-plugin
module.exports = {"siteAttributes":"SiteAttributes_siteAttributes__2xHJv","table":"SiteAttributes_table__1DcHG"};